import { matchRoutes, useLocation } from 'react-router-dom';
import { PageAbsolutePath } from '../../consts/Common';

export const useCurrentPath = (): string => {
  const routes = [
    { path: PageAbsolutePath.Renewals.Landing },
    { path: PageAbsolutePath.Renewals.PersonalDetails },
    { path: PageAbsolutePath.Renewals.VehicleDetails },
    { path: PageAbsolutePath.Renewals.Quote },
    { path: PageAbsolutePath.Renewals.Summary },
    { path: PageAbsolutePath.Renewals.DirectDebit },
    { path: PageAbsolutePath.Renewals.SinglePayment },
    { path: PageAbsolutePath.Renewals.Confirmation },
    { path: PageAbsolutePath.Renewals.FailedRegistration },
    { path: PageAbsolutePath.Renewals.LateRenewalAcceptance },
    { path: PageAbsolutePath.Customer.Landing },
    { path: PageAbsolutePath.Customer.VehicleDetails },
    { path: PageAbsolutePath.Customer.Products },
    { path: PageAbsolutePath.Customer.CreatePlan },
    { path: PageAbsolutePath.Customer.PersonalDetails },
    { path: PageAbsolutePath.Customer.Summary },
    { path: PageAbsolutePath.Customer.DirectDebit },
    { path: PageAbsolutePath.Customer.SinglePayment },
    { path: PageAbsolutePath.Customer.Confirmation },
    { path: PageAbsolutePath.Customer.FailedRegistration },
    { path: PageAbsolutePath.Customer.PaymentAssistSuccess },
    { path: PageAbsolutePath.Customer.PaymentAssistFailure },
    { path: PageAbsolutePath.Landing },
    { path: PageAbsolutePath.VehicleDetails },
    { path: PageAbsolutePath.Products },
    { path: PageAbsolutePath.CreatePlan },
    { path: PageAbsolutePath.PersonalDetails },
    { path: PageAbsolutePath.Summary },
    { path: PageAbsolutePath.DirectDebit },
    { path: PageAbsolutePath.SinglePayment },
    { path: PageAbsolutePath.Confirmation },
    { path: PageAbsolutePath.FailedRegistration },
    { path: PageAbsolutePath.UnderMaintenance },
    { path: PageAbsolutePath.PaymentAssistSuccess },
    { path: PageAbsolutePath.Error },
    { path: PageAbsolutePath.Insurance.Landing },
    { path: PageAbsolutePath.Insurance.DealerLandingPage },
    { path: PageAbsolutePath.Insurance.AboutYou },
    { path: PageAbsolutePath.Insurance.DrivingHistory },
    { path: PageAbsolutePath.Insurance.VehicleDetails },
    { path: PageAbsolutePath.Insurance.InsuranceCoverDetailsPage },
    { path: PageAbsolutePath.Insurance.AddressDetailsPage },
    { path: PageAbsolutePath.Insurance.AdditionalDriverDetailsPage },
    { path: PageAbsolutePath.Insurance.YourQuote },
    { path: PageAbsolutePath.Insurance.ConfirmationPage },
    { path: PageAbsolutePath.Insurance.OptionalCover },
    { path: PageAbsolutePath.Insurance.PaymentPage },
    { path: PageAbsolutePath.Insurance.CheckYourDetails },
    { path: PageAbsolutePath.Insurance.PolicyConfirmation },
    { path: PageAbsolutePath.Insurance.DealerLoginPage },
    { path: PageAbsolutePath.Insurance.DealersHomePage },
    { path: PageAbsolutePath.Insurance.DealersAdminPage },
    { path: PageAbsolutePath.Insurance.DealersResources },
    { path: PageAbsolutePath.Insurance.Referral },
    { path: PageAbsolutePath.Insurance.SiteMap },
    { path: PageAbsolutePath.Insurance.MotorInsuranceClaim },
    { path: PageAbsolutePath.Insurance.EligibilityAncillaryPage },
    { path: PageAbsolutePath.Insurance.AlternateEligibility },
    { path: PageAbsolutePath.Insurance.OrderVerification },
    { path: PageAbsolutePath.Insurance.AncillaryPage },
    { path: PageAbsolutePath.Insurance.FairUseNoticePage },
    { path: PageAbsolutePath.Insurance.TermsUseAncillaryPage },
    { path: PageAbsolutePath.Insurance.BusinessTermsAncillaryPage },
    { path: PageAbsolutePath.Insurance.TermsAndConditions },
    { path: PageAbsolutePath.Insurance.CoverDetailsPage },
    { path: PageAbsolutePath.Insurance.ElectricVehiclePage },
    { path: PageAbsolutePath.Insurance.ExcessReturnPolicyTermsConditions },
    { path: PageAbsolutePath.Insurance.FaqsPage },
    { path: PageAbsolutePath.Insurance.RetrieveQuote },
    { path: PageAbsolutePath.Insurance.ProofOfNcd },
    { path: PageAbsolutePath.Insurance.RegisterExcessReturn },
    { path: PageAbsolutePath.Insurance.CustomerSelfRegistration },
    { path: PageAbsolutePath.Insurance.DriveAway },
    { path: PageAbsolutePath.Insurance.PolicyDocuments },
    { path: PageAbsolutePath.Insurance.YourQuote },
    { path: PageAbsolutePath.Insurance.FailedRegistration },
    { path: PageAbsolutePath.Insurance.AboutTermsOfBusinessAndFairUsageNotice },
    { path: PageAbsolutePath.Insurance.ImportantNoticeInformation },
    { path: PageAbsolutePath.Insurance.SettingUpDirectDebit },
    { path: PageAbsolutePath.Insurance.UpdatePreferencesPage },
    { path: PageAbsolutePath.Insurance.PostcodeConfirmationPage },
    { path: PageAbsolutePath.Insurance.AccidentAssistance },
    { path: PageAbsolutePath.Insurance.ServiceExcess },
    { path: PageAbsolutePath.InsuranceRedirect.FairUseNotice }
  ];

  const location = useLocation();
  const matchedRoutes = matchRoutes(routes, location);

  if (matchedRoutes?.length === 1) {
    return matchedRoutes[0].route?.path || '';
  }

  return '';
};
